'use strict';

var React = require('react'),
    _ = require('underscore'),
    FormMixin = require('../mixins/FormMixin'),
    FormInputRow = require('../molecules/FormInputRow'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    BtnGroup = require('../molecules/BtnGroup'),
    validateEmail = require('../utils/validateEmail'),
    FormStore = require('../stores/FormStore'),
    UserActionCreators = require('../actions/UserActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var RequestResetPassword = React.createClass({
  mixins: [FormMixin, PureRenderMixin],

  propTypes: {
    onCloseClick: React.PropTypes.func.isRequired,
    onCancelClick: React.PropTypes.func.isRequired
  },

  getInitialState: function () {
    return {
      email: FormStore.getDefaultValue('email'),
    };
  },

  render: function () {
    return (
      <div className='Modal-body'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Reset Password
          </h3>
          <div onTouchTap={_.partial(this.props.onCloseClick, undefined)} className='Modal-close'>
            <Icon name='cross' size='small' mode='stroke' />
          </div>
        </div>
        <div className='Modal-content'>
          <div className='Form'>
            <FormInputRow label='Email Address'
                          type='email'
                          formLink={this.linkValidatedState('email', validateEmail)} />
          </div>
        </div>
        {this.renderFooter()}
      </div>
    );
  },

  renderFooter: function () {
    return (
      <div className='Modal-footer'>
        <BtnGroup>
          <Button color='green'
                  size='large'
                  onClick={this.submitForm.bind(this, this.sendRequest)}
                  disabled={!this.isFormEditable()}>
            Reset
          </Button>
          <Button color='gray'
                  size='large'
                  onClick={this.handleCancelClick}
                  disabled={!this.isFormEditable()}>
            Cancel
          </Button>
        </BtnGroup>
      </div>
    );
  },

  handleCancelClick: function () {
    this.props.onCancelClick({
      email: this.state.email
    });
  },

  sendRequest: function () {
    UserActionCreators.requestResetPassword({
      email: this.state.email
    });
  }
});

module.exports = RequestResetPassword;



/** WEBPACK FOOTER **
 ** ./modals/RequestResetPassword.jsx
 **/